import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  action,
  eyebrow,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  eyebrow?: string;
}) {
  return (
    <header className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
        <h1 className="font-display text-[30px] font-semibold leading-tight text-ink md:text-[40px]">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-[14.5px] text-ink-muted">{subtitle}</p>}
      </div>
      {action}
    </header>
  );
}
